/**
 * INFINITY LIFE 2.0 — Navigation Sidebar (Desktop) and Bottom Bar (Mobile)
 */

import { store } from '../state.js';

export function renderNavbar() {
  const { currentView, user, theme } = store.get();
  const isOwner = !!user && (user.is_owner === true || user.role === 'owner' || user.email === 'admshuran@gmail.com');

  return `
    <!-- Desktop Sidebar -->
    <aside class="sidebar">
      <div class="brand-section">
        <img src="/icons/icon-192.svg" alt="Infinity Life" class="brand-logo" />
        <div class="brand-title">
          <span>INFINITY</span>
          <span class="brand-subtitle">Life OS 2.0</span>
        </div>
      </div>

      <nav class="nav-menu">
        <button class="nav-link ${currentView === 'my-day' ? 'active' : ''}" data-view="my-day">
          <span class="nav-icon">☀️</span>
          <span>Meu Dia</span>
        </button>

        <button class="nav-link ${currentView === 'agenda' ? 'active' : ''}" data-view="agenda">
          <span class="nav-icon">📅</span>
          <span>Agenda & Tarefas</span>
        </button>

        <button class="nav-link ${currentView === 'business' ? 'active' : ''}" data-view="business">
          <span class="nav-icon">💼</span>
          <span>Meu Negócio</span>
        </button>

        ${isOwner ? `
          <button class="nav-link ${currentView === 'admin' ? 'active' : ''}" data-view="admin">
            <span class="nav-icon">🛡️</span>
            <span>Painel Proprietário</span>
          </button>
        ` : ''}

        <button class="nav-link ${currentView === 'landing' ? 'active' : ''}" data-view="landing" style="margin-top: 10px; border-top: 1px dashed var(--border-subtle); padding-top: 12px;">
          <span class="nav-icon">🌐</span>
          <span>Página de Vendas</span>
        </button>
      </nav>

      <div class="sidebar-footer">
        <!-- Theme Switcher -->
        <button class="btn-secondary" id="btn-theme-toggle" style="width: 100%; justify-content: center;">
          <span>${theme === 'light' ? '🌙 Modo Escuro' : '☀️ Modo Claro'}</span>
        </button>

        <div style="font-size: 0.72rem; color: var(--text-muted); text-align: center; margin-top: 4px;">
          Infinity Life v2.0 • Hostinger Ready
        </div>
      </div>
    </aside>

    <!-- Mobile Bottom Navigation -->
    <nav class="bottom-nav">
      <button class="bottom-nav-item ${currentView === 'my-day' ? 'active' : ''}" data-view="my-day">
        <span class="bottom-nav-icon">☀️</span>
        <span>Meu Dia</span>
      </button>

      <button class="bottom-nav-item ${currentView === 'agenda' ? 'active' : ''}" data-view="agenda">
        <span class="bottom-nav-icon">📅</span>
        <span>Agenda</span>
      </button>

      <button class="bottom-nav-item ${currentView === 'business' ? 'active' : ''}" data-view="business">
        <span class="bottom-nav-icon">💼</span>
        <span>Negócio</span>
      </button>

      ${isOwner ? `
        <button class="bottom-nav-item ${currentView === 'admin' ? 'active' : ''}" data-view="admin">
          <span class="bottom-nav-icon">🛡️</span>
          <span>Admin</span>
        </button>
      ` : `
        <button class="bottom-nav-item" id="btn-mobile-profile">
          <span class="bottom-nav-icon">👤</span>
          <span>Conta</span>
        </button>
      `}
    </nav>

    <!-- Mobile Floating Action Button -->
    <button class="fab-btn" id="fab-add-task" title="Adicionar Tarefa">
      <span>＋</span>
    </button>
  `;
}

export function attachNavbarEvents(container) {
  // Navigation view clicks
  container.querySelectorAll('[data-view]').forEach((el) => {
    el.addEventListener('click', () => {
      const view = el.dataset.view;
      store.setView(view);
    });
  });

  // Theme toggle
  const themeBtn = container.querySelector('#btn-theme-toggle');
  if (themeBtn) {
    themeBtn.addEventListener('click', () => {
      const { theme } = store.get();
      const next = theme === 'light' ? 'dark' : 'light';
      store.setTheme(next);
    });
  }

  // Mobile profile button
  const mobileProfileBtn = container.querySelector('#btn-mobile-profile');
  if (mobileProfileBtn) {
    mobileProfileBtn.addEventListener('click', () => store.toggleModal('auth'));
  }

  // Mobile FAB
  const fab = container.querySelector('#fab-add-task');
  if (fab) {
    fab.addEventListener('click', () => store.openTaskModal());
  }
}
